(function () {
  'use strict';

  const root = document.documentElement;
  const body = document.body;
  const routes = window.Vianey && window.Vianey.routes;
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents);
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'USD' }).format(Number(cents || 0) / 100);
  }

  function qs(selector, scope) { return (scope || document).querySelector(selector); }
  function qsa(selector, scope) { return Array.from((scope || document).querySelectorAll(selector)); }
  function showToast(message) {
    const toast = qs('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  }

  function openDrawer() { body.classList.add('drawer-open', 'no-scroll'); const drawer = qs('[data-cart-drawer]'); if (drawer) drawer.setAttribute('aria-hidden', 'false'); }
  function closeDrawer() { body.classList.remove('drawer-open', 'no-scroll'); const drawer = qs('[data-cart-drawer]'); if (drawer) drawer.setAttribute('aria-hidden', 'true'); }
  qsa('[data-cart-toggle]').forEach(function (button) { button.addEventListener('click', openDrawer); });
  qsa('[data-drawer-close]').forEach(function (button) { button.addEventListener('click', closeDrawer); });

  const menu = qs('[data-mobile-menu]');
  qsa('[data-menu-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (!menu) return;
      menu.classList.toggle('is-open');
      menu.setAttribute('aria-hidden', menu.classList.contains('is-open') ? 'false' : 'true');
      body.classList.toggle('no-scroll', menu.classList.contains('is-open'));
    });
  });

  const searchPanel = qs('[data-search-panel]');
  qsa('[data-search-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (!searchPanel) return;
      searchPanel.classList.toggle('is-open');
      searchPanel.setAttribute('aria-hidden', searchPanel.classList.contains('is-open') ? 'false' : 'true');
      if (searchPanel.classList.contains('is-open')) {
        const input = qs('[data-predictive-search]', searchPanel);
        if (input) window.setTimeout(function () { input.focus(); }, 100);
      }
    });
  });

  const predictiveInput = qs('[data-predictive-search]');
  const predictiveResults = qs('[data-predictive-results]');
  let predictiveTimer;
  if (predictiveInput && predictiveResults && routes) {
    predictiveInput.addEventListener('input', function () {
      const value = predictiveInput.value.trim();
      window.clearTimeout(predictiveTimer);
      if (value.length < 2) { predictiveResults.innerHTML = ''; return; }
      predictiveTimer = window.setTimeout(function () {
        fetch(routes.searchSuggest + encodeURIComponent(value), { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            const products = data.resources && data.resources.results && data.resources.results.products || [];
            predictiveResults.innerHTML = products.length ? products.map(function (product) {
              return '<a class="predictive-result" href="' + product.url + '">' + (product.image ? '<img src="' + product.image + '" alt="">' : '') + '<span>' + product.title + '</span></a>';
            }).join('') : '<p class="muted">No products found yet.</p>';
          })
          .catch(function () { predictiveResults.innerHTML = ''; });
      }, 220);
    });
  }

  function updateCartUI(cart) {
    qsa('[data-cart-count]').forEach(function (element) { element.textContent = cart.item_count; });
    const items = qs('[data-cart-items]');
    if (items) {
      if (!cart.item_count) {
        items.innerHTML = '<div class="cart-empty"><p class="cart-empty__title">' + (window.Vianey.strings.empty || 'Your bag is empty.') + '</p><p class="muted">Your next beauty ritual is waiting.</p><a href="/collections/all" class="button button--dark">Explore the edit</a></div>';
      } else {
        items.innerHTML = cart.items.map(function (item, index) {
          return '<div class="cart-item" data-cart-item data-line="' + (index + 1) + '">' +
            '<a href="' + item.url + '" class="cart-item__image">' + (item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '">' : '') + '</a>' +
            '<div class="cart-item__details"><a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' +
            (item.variant_title !== 'Default Title' ? '<p class="muted">' + item.variant_title + '</p>' : '') +
            '<div class="cart-item__bottom"><span>' + formatMoney(item.final_line_price) + '</span><div class="quantity" aria-label="Quantity"><button type="button" data-quantity-change data-line="' + (index + 1) + '" data-quantity="' + Math.max(0, item.quantity - 1) + '">−</button><span>' + item.quantity + '</span><button type="button" data-quantity-change data-line="' + (index + 1) + '" data-quantity="' + (item.quantity + 1) + '">+</button></div></div><button type="button" class="text-button cart-item__remove" data-quantity-change data-line="' + (index + 1) + '" data-quantity="0">Remove</button></div></div>';
        }).join('');
      }
    }
    const subtotal = qs('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    const footer = qs('[data-cart-footer]');
    if (footer) footer.hidden = !cart.item_count;
    if (cart.item_count) openDrawer();
    bindCartEvents();
  }
  function fetchCart() { return fetch(routes.cartJs, { headers: { Accept: 'application/json' } }).then(function (response) { return response.json(); }); }
  function changeCart(line, quantity) {
    return fetch(routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) }).then(function (response) { return response.json(); }).then(updateCartUI);
  }
  function addToCart(id, quantity) {
    return fetch(routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] }) })
      .then(function (response) { if (!response.ok) throw new Error('cart'); return response.json(); }).then(function () { return fetchCart(); }).then(function (cart) { updateCartUI(cart); showToast(window.Vianey.strings.added || 'Added to your bag'); });
  }
  function bindCartEvents() {
    qsa('[data-quantity-change]').forEach(function (button) {
      button.onclick = function () { button.disabled = true; changeCart(button.dataset.line, Number(button.dataset.quantity)).catch(function () { showToast(window.Vianey.strings.error); }).finally(function () { button.disabled = false; }); };
    });
  }
  bindCartEvents();
  qsa('[data-quick-add]').forEach(function (button) { button.addEventListener('click', function () { addToCart(button.dataset.quickAdd).catch(function () { showToast(window.Vianey.strings.error); }); }); });

  qsa('[data-wishlist]').forEach(function (button) {
    const key = 'vianey-wishlist';
    let saved = [];
    try { saved = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
    if (saved.indexOf(button.dataset.wishlist) !== -1) button.classList.add('is-saved');
    button.addEventListener('click', function () {
      const index = saved.indexOf(button.dataset.wishlist);
      if (index === -1) saved.push(button.dataset.wishlist); else saved.splice(index, 1);
      localStorage.setItem(key, JSON.stringify(saved));
      qsa('[data-wishlist="' + button.dataset.wishlist + '"]').forEach(function (element) { element.classList.toggle('is-saved', saved.indexOf(button.dataset.wishlist) !== -1); });
      showToast(index === -1 ? 'Saved to wishlist' : 'Removed from wishlist');
    });
  });

  const productSection = qs('[data-product-section]');
  if (productSection) {
    const variantSelect = qs('[data-variant-select]', productSection);
    let variantData = [];
    const variantScript = qs('[data-product-variants]');
    try { variantData = variantScript ? JSON.parse(variantScript.textContent) : []; } catch (e) { variantData = []; }
    function selectedOptions() { return qsa('.product-option input:checked', productSection).map(function (input) { return input.value; }); }
    function syncVariant() {
      if (!variantSelect || !variantData.length) return;
      const match = variantData.find(function (variant) { return variant.options.every(function (option, index) { return option === selectedOptions()[index]; }); });
      if (match) {
        variantSelect.value = match.id;
        const submit = qs('[data-add-to-cart]', productSection);
        if (submit) { submit.disabled = !match.available; submit.childNodes[0].textContent = match.available ? 'Add to bag ' : 'Sold out '; }
      }
    }
    qsa('.product-option input', productSection).forEach(function (input) { input.addEventListener('change', syncVariant); });
    const quantityInput = qs('[data-product-quantity-input]', productSection);
    qsa('[data-product-quantity]', productSection).forEach(function (button) { button.addEventListener('click', function () { if (!quantityInput) return; quantityInput.value = Math.max(1, Number(quantityInput.value) + (button.dataset.productQuantity === 'plus' ? 1 : -1)); }); });
    const form = qs('[data-product-form]', productSection);
    if (form) form.addEventListener('submit', function (event) { event.preventDefault(); const submit = qs('[data-add-to-cart]', form); if (submit && !submit.disabled) { submit.disabled = true; addToCart(variantSelect ? variantSelect.value : form.querySelector('[name="id"]').value, quantityInput ? quantityInput.value : 1).catch(function () { showToast(window.Vianey.strings.error); }).finally(function () { submit.disabled = false; }); } });
    qsa('[data-thumb-index]').forEach(function (thumb) { thumb.addEventListener('click', function () { const index = Number(thumb.dataset.thumbIndex); const media = qsa('[data-product-media]', productSection)[index]; if (media) media.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); qsa('[data-thumb-index]').forEach(function (el) { el.classList.toggle('is-active', el === thumb); }); }); });
    const lightbox = qs('[data-lightbox]');
    qsa('[data-zoom-trigger]').forEach(function (button) { button.addEventListener('click', function () { const image = button.parentElement.querySelector('img'); if (!image || !lightbox) return; qs('[data-lightbox-image]').src = image.currentSrc || image.src; qs('[data-lightbox-image]').alt = image.alt; lightbox.classList.add('is-open'); lightbox.setAttribute('aria-hidden', 'false'); body.classList.add('no-scroll'); }); });
    qsa('[data-lightbox-close]', lightbox).forEach(function (button) { button.addEventListener('click', function () { lightbox.classList.remove('is-open'); lightbox.setAttribute('aria-hidden', 'true'); body.classList.remove('no-scroll'); }); });
    const sticky = qs('[data-sticky-add]');
    const stickySubmit = qs('[data-sticky-submit]');
    if (sticky && stickySubmit) {
      const observer = new IntersectionObserver(function (entries) { sticky.classList.toggle('is-visible', !entries[0].isIntersecting); }, { threshold: .1 });
      observer.observe(form);
      stickySubmit.addEventListener('click', function () { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }
  }

  qsa('[data-filter-toggle]').forEach(function (button) { button.addEventListener('click', function () { const filters = qs('[data-filters]'); if (filters) filters.classList.toggle('is-open'); }); });
  const sortSelect = qs('[data-sort-select]');
  if (sortSelect) sortSelect.addEventListener('change', function () { const url = new URL(window.location.href); url.searchParams.set('sort_by', sortSelect.value); window.location.href = url.toString(); });

  qsa('[data-age-gate]').forEach(function (gate) {
    const key = 'vianey-age-confirmed-' + gate.dataset.ageGateKey;
    if (sessionStorage.getItem(key) !== 'true') { gate.classList.add('is-open'); gate.setAttribute('aria-hidden', 'false'); body.classList.add('no-scroll'); }
    const confirm = qs('[data-age-confirm]', gate);
    if (confirm) confirm.addEventListener('click', function () { sessionStorage.setItem(key, 'true'); gate.classList.remove('is-open'); gate.setAttribute('aria-hidden', 'true'); body.classList.remove('no-scroll'); });
  });
  qsa('[data-after-dark-enter]').forEach(function (button) { button.addEventListener('click', function () { const gate = qs('[data-age-gate]'); if (gate) { gate.classList.add('is-open'); gate.setAttribute('aria-hidden', 'false'); body.classList.add('no-scroll'); } }); });
}());